import { useCallback, useEffect } from "react";

interface ChatWidgetInterface {
  apiKey: string;
}

const ChatWidget: React.FC<ChatWidgetInterface> = ({ apiKey }) => {
  const embedScript = useCallback(() => {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.id = "widget-container";
    s.async = true;
    s.innerHTML = `MeetParker.init("${apiKey}")`;

    document.body.appendChild(s);
  }, [apiKey]);

  const removeExistingScript = () => {
    document.querySelectorAll("#meetparker-widget").forEach((el) => {
      document.body.removeChild(el);
    });
  };

  useEffect(() => {
    removeExistingScript();
    embedScript();
  }, [apiKey, embedScript]);

  return null;
};

export default ChatWidget;
